import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export function postTelemetries(data: any) {
  return unauthenticatedHttp()
    .post(`${window.env.UNAUTH_API}/telemetry`, data)
    .catch(() => {
      // Ignore telemetry errors
    });
}
